export default __webpack_public_path__ + "static/media/Heirs-Magazine.0d33df14.jpg";